import { IButton } from 'common/builder/buttons/buttonInterfaces'
import {
  ButtonConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

export const FallbackButtonGenericConverterRule: ConverterRule<
  IButton,
  FlowChartButton,
  ButtonConverterRulePayload
> = {
  predicate: () => true,

  convert: () => null,
}
